import "./src/assets/css/main.css";
import "./src/assets/css/normalize.css";
import "./src/assets/css/resets.css";
import Layout from "./src/components/Layout";

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined" && typeof window.ym === "function") {
    window.ym(112980575, 'hit', location.pathname);
  }
};